export default __webpack_public_path__ + "static/zitrone_01-2ae5a701c32756493be29088a266909b.png";